import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Input from 'src/components/Input/Input';

export const EditFreshchatApiDetailsSettings = ({ integration }) => {
  const { control } = useFormContext();
  return (
    <div className={'w-full flex flex-col gap-2.5 p-2.5 bg-[#A498FF1A] rounded-sm-5'}>
      <div>
        <Controller
          control={control}
          name="chat_url"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              label={'Chat URL'}
              placeholder={'https://chat.openai.com/c/12345678-abcd-efgh-ijkl-9876543210mn'}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
              infoTooltip={{
                side: 'right',
                description: (
                  <>
                    Freshchat Admin Settings → Marketplace <br /> & Integrations → API Settings →
                    Chat URL
                  </>
                ),
              }}
            />
          )}
        />
      </div>
      <div>
        <Controller
          control={control}
          name="api_key"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              label={'API Key'}
              placeholder={'sk-4r4nD0mL3tt3r5AndNum83r5XXXXXXXXXXXXXXX'}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
              infoTooltip={{
                side: 'right',
                description: (
                  <>
                    Freshchat Admin Settings → Marketplace
                    <br /> & Integrations → API Settings → Generate Token
                  </>
                ),
              }}
            />
          )}
        />
      </div>
    </div>
  );
};
